import { environment } from '../environment';
import compare from '../core/map/compare';
import { ControlType } from './item';
import { _loadingCount } from '../shared/loading';
import map from '../core/map';
import Storage from '../storage';

const Workspace = (() => {
    let _workspaceName = undefined;
    let _workspaces = undefined;
    let _principal = undefined;
    let _processingAjax = 0;
    let _processingEvents = false;
    let _eventLoop = [];

    const _timeStartSave = 1000 * 60;
    const _timeLoopSave = 1000 * 10;
    const _lastSession = 'LastSession';
    const _currentSession = 'CurrentSession';
    const _restoresActions = {
        [ControlType.TypeaHead]: (item) => $(item.id).trigger('typeahead:selected', item.value),
        [ControlType.MapToggle]: (item) => {
            if (item.value) {
                compare.toggle();
            }
        },
        [ControlType.DialogOption]: (item) => _sleep(500).then(() => {
            $(item.id).trigger('click');
        }),
        [ControlType.ICheckBox]: (item) => _sleep(500).then(() => {
            const checked = item.value ? 'check' : 'uncheck';
            $(item.id).iCheck(checked);
        }),
        [ControlType.ICheckRadio]: (item) => _sleep(500).then(() => {
            const checked = item.value.checked ? 'check' : 'uncheck';
            $($(item.id)
                .filter((_, el) => el.value === item.value.value))
                .iCheck(checked);
        }),
        [ControlType.KendoButton]: (item) => _sleep(500).then(() => {
            $(item.id).trigger('click');
        }),
        [ControlType.KendoMobileButtonGroup]: (item) => {
            const button = $(item.id).data('kendoMobileButtonGroup');

            if(button) {
                button.select(item.value);
                button.trigger('select', { index: item.value });
            }
        },
        [ControlType.KendoDropDownList]: (item) => {
            const dropDownList = $(item.id).data('kendoDropDownList');

            if(dropDownList) {
                dropDownList.value(item.value);
                dropDownList.trigger('change');
            }
        },
        [ControlType.KendoDatePicker]: (item) => {
            const dataPicker = $(item.id).data('kendoDatePicker');

            if(dataPicker) {
                dataPicker.value(item.value);
                dataPicker.trigger('change');
            }
        },
        [ControlType.KendoSlider]: (item) => {
            const slider = $(item.id).data('kendoSlider');

            if(slider) {
                slider.trigger('change', { value: item.value });
                slider.setOptions({ value: item.value });
            }
        },
        [ControlType.GlobalEvent]: (item) => $(document).trigger(item.id),
        [ControlType.Input]: (item) => {
            $(item.id).val(item.value);
            $(item.id).trigger('change');
        },
        [ControlType.InputCheckbox]: (item) => {
            $(item.id).prop('checked', item.value);
            $(item.id).trigger('change');
        },
        [ControlType.InputButton]: (item) => $(item.id).trigger('click'),
        [ControlType.KendoMultiselect]: (item) => {
            const select = $(item.id).data('kendoMultiSelect');

            if(select) {
                select.value(item.value);
                select.trigger('change');
            }
        },
        [ControlType.MapView]: (item) => map.setView(L.latLng(item.value.latlng), item.value.zoom)
    };

    const _getWorkspaceStorage = () => new Map(Storage.get(_workspaceName));

    const _watchRequestAjaxForProcessing = () => {
        var proxied = window.XMLHttpRequest.prototype.send;
        window.XMLHttpRequest.prototype.send = function() {
            _processingAjax++;

            var pointer = this;
            var intervalId = window.setInterval(function() {
                if (pointer.readyState != 4) {
                    return;
                }

                clearInterval(intervalId);
                _processingAjax--;
            }, 1);
            return proxied.apply(this, [].slice.call(arguments));
        };
    };

    const _create = (workspace) => {
        if (!_workspaces) {
            _workspaces = _getWorkspaceStorage();
        }

        if (!_workspaces.has(workspace)) {
            const currentSession = _workspaces.get(_currentSession) || { actions: [] };
            _workspaces.set(workspace, { date: new Date(), actions: currentSession.actions });
        }
    };

    const _sleep = (ms) => {
        _processingAjax++;
        return new Promise(resolve =>
            setTimeout(() => {
                _processingAjax--;
                resolve();
            }, ms)
        );
    };

    const _processEvent = () => {
        const processEvent = setInterval(() => {
            try {
                _processingEvents = true;

                if (_processingAjax === 0 && _loadingCount === 0) {
                    const [process, ...pending] = _eventLoop;
                    _eventLoop = pending;

                    if (process) {
                        _sleep(100).then(process);
                    }

                    if (_eventLoop.length) {
                        _processEvent();
                    } else {
                        _processingEvents = false;
                        clearInterval(processEvent);
                    }
                }
            } catch (err) {
                clearInterval(processEvent);
                throw err;
            }
        }, 1);

        const verifyRestoreLoading = setInterval(() => {
            if (!_eventLoop.length && _processingAjax === 0 && _loadingCount === 0) {
                _hideLoading();
                clearInterval(verifyRestoreLoading);
            }
        }, 1);
    };

    const _addProcessEvent = (func, item) => {
        const funcExtended = () => {
            map.selectMap(item.idMap);
            func(item);
        };

        _eventLoop = [..._eventLoop, funcExtended];
    };

    const _setPrincipal = (workspace) => {
        _principal = workspace;
    };

    const _showLoading = () => {
        $('body').append(`<div id='restore_loading' class='alertify' style='z-index: 999999999999;'><div class='dialog'><div><p class='msg'><h4 style='margin:0;padding:10px'><i class='fa fa-cog fa-spin fa-1x fa-fw'></i>Restaurando sessão...</h4></p></div></div></div>`);
    };

    const _hideLoading = () => {
        $('#restore_loading').remove();
    };

    const _restore = (workspace) => {
        _showLoading();

        const restoreWorkspace = _workspaces.get(workspace);
        restoreWorkspace.actions.forEach(item => _addProcessEvent(_restoresActions[item.type], item));
        _workspaces.set(_currentSession, restoreWorkspace);
        _processEvent();

        Storage.remove('restore');
    };

    const _startAutoSave = () => {
        const saveWorkspaces = () => {
            if (!_processingEvents) {
                _saveToStorage();
            }
        };

        setTimeout(() => {
            saveWorkspaces();

            setInterval(saveWorkspaces, _timeLoopSave);
        }, _timeStartSave);
    };

    const _checkAndDoRestore = () => {
        const restore = Storage.get('restore');

        if (restore) {
            _restore(restore);
        }
    };

    const _saveToStorage = () => {
        const currentWorkspace = _workspaces.get(_currentSession);

        const workspacesSave = [..._workspaces]
            .filter(workspace => workspace[0] !== _currentSession)
            .map(workspace => {
                if (workspace[0] === _lastSession || workspace[0] === _principal) {
                    workspace[1] = currentWorkspace;
                }

                return workspace;
            });

        Storage.save(_workspaceName, workspacesSave);
    };

    const _hackAjustMapAfterRestore = () => {
        const processingEventListerner = setInterval(() => {
            if (!_processingEvents) {
                setImmediate(() => map.fire('dragend')); // hack ajust map layers after restore
                clearInterval(processingEventListerner);
            }
        }, 100);
    };

    return {
        init() {
            _workspaceName = `neogig_workspaces_${environment.get('CONFIG.CLIENT').toLowerCase()}`;
            _create(_lastSession);
            _create(_currentSession);
            _watchRequestAjaxForProcessing();
            _checkAndDoRestore();
            _startAutoSave();
            _hackAjustMapAfterRestore();
        },
        setPrincipal(workspace) {
            _setPrincipal(workspace);
        },
        list() {
            const workspaces = _getWorkspaceStorage();
            return [...workspaces.keys()]
                .filter(key => key !== _currentSession && key !== _lastSession)
                .map(key => ({ name: key, date: workspaces.get(key).date, isPrincipal: _principal === key }));
        },
        addAction(action) {
            if (_processingEvents) {
                return;
            }

            [_lastSession, _principal, _currentSession]
                .filter(workspace => typeof workspace !== 'undefined')
                .forEach(workspace =>
                     _workspaces.set(workspace, ({
                        date: new Date(),
                        actions: [..._workspaces.get(workspace).actions, action]
                    }))
                );
        },
        create(workspace) {
            _create(workspace);
        },
        remove(workspace) {
            const workspaces = _getWorkspaceStorage();
            workspaces.delete(workspace);
            _workspaces.delete(workspace);
            Storage.save(_workspaceName, workspaces);
        },
        restoreLastSession() {
            this.doRestore(_lastSession);
        },
        save() {
            _saveToStorage();
        },
        doRestore(workspace) {
            Storage.save('restore', workspace);
            location = '/';
        }
    };
})();

export default Workspace;



// WEBPACK FOOTER //
// ./src/scripts/workspaces/index.js